import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { HTTP_VERBS } from 'utils/constants';
import { ALERT_VARIANTS, LOCALIZATION_PAGES, API_ENDPOINTS } from 'utils/constants';
import { useRoot } from 'context/RootContext';

const useCreateTicketType = values => {
  const path = API_ENDPOINTS.TICKET_TYPES;

  const { t } = useTranslation(LOCALIZATION_PAGES.TICKET_TYPES);
  const { showNotification } = useRoot();
  const [{ result, loading, error }, createTicketType] = useApi(path, {
    initialFetch: false,
    verb: HTTP_VERBS.POST,
    data: values,
  });

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('ticket_type_create_fail'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  useEffect(() => {
    if (result) {
      showNotification({
        message: t('ticket_type_create_success'),
      });
    }
  }, [result, showNotification, t]);

  return [{ result, loading, error }, createTicketType];
};

export default useCreateTicketType;
